// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"255":"test","389":"404","962":"home"}[chunkId] || chunkId) + "." + {"255":"11508bf2","389":"c6fa9534","855":"c5a1a07e","962":"83e53dec"}[chunkId] + ".js";
};